import React, { useState } from 'react';
import { Box, Typography, IconButton, Paper, useTheme } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const steps = [
    {
        title: 'Vantagens Técnicas e Criptográficas',
        description: 'Prova de anterioridade irrefutável com Timestamping. Manutenção do segredo industrial registrando apenas hashes, garantindo alta velocidade, acesso imediato e alcance global sem limitações territoriais.'
    },
    {
        title: 'Vantagens Operacionais e de Automação',
        description: 'Custos marginais, gestão de acesso condicionada (Token-Gating) e execução imediata de penalidades (Slashing) por meio de contratos inteligentes, reduzindo burocracia.'
    },
    {
        title: 'Vantagens de Rastreabilidade',
        description: 'Criação de um gêmeo digital que garante a certificação de origem e qualidade, combatendo falsificações diretamente na ponta de consumo e integrando o mundo físico ao digital.'
    },
    {
        title: 'Vantagens Econômicas e Defesa Sistêmica',
        description: 'Fortalecimento do efeito de rede, possibilitando fracionamento e liquidez dos ativos, além de garantir o Direito de Usuário Anterior em jurisdições legais tradicionais.'
    }
];

const IpRegistrationCarousel: React.FC = () => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = steps.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
    };

    return (
        <Box sx={{ maxWidth: 800, flexGrow: 1, margin: 'auto', mb: 4, mt: 2 }}>
            <Paper
                square
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: 180,
                    p: 3,
                    bgcolor: 'background.default',
                    borderRadius: 2,
                    textAlign: 'center',
                    justifyContent: 'center',
                    position: 'relative'
                }}
            >
                <IconButton 
                    onClick={handleBack} 
                    sx={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)' }}
                >
                    <ArrowBackIosNewIcon />
                </IconButton>

                <Box sx={{ px: 4 }}>
                    <Typography variant="h6" color="primary" gutterBottom>
                        {steps[activeStep].title}
                    </Typography>
                    <Typography variant="body1">
                        {steps[activeStep].description}
                    </Typography>
                </Box>

                <IconButton 
                    onClick={handleNext} 
                    sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)' }}
                >
                    <ArrowForwardIosIcon />
                </IconButton>
                
                <Box sx={{ position: 'absolute', bottom: 8, display: 'flex', gap: 1 }}>
                    {steps.map((_, index) => (
                        <Box 
                            key={index} 
                            sx={{
                                width: 8, 
                                height: 8, 
                                borderRadius: '50%', 
                                bgcolor: index === activeStep ? theme.palette.primary.main : 'text.disabled'
                            }} 
                        />
                    ))}
                </Box>
            </Paper>
        </Box>
    );
};

export default IpRegistrationCarousel;
